import type { Directive, DirectiveBinding } from 'vue';
import { NO_CAPTURE_CLASS } from '@shared/common/tracking/domain/constant/no-capture.constant';

const updateNoCaptureClass = (el: HTMLElement, binding: DirectiveBinding<unknown>) => {
  if (binding.value === false) {
    el.classList.remove(NO_CAPTURE_CLASS);
    return;
  }

  el.classList.add(NO_CAPTURE_CLASS);
};

export const noCaptureDirective: Directive<HTMLElement, unknown> = {
  mounted(el, binding) {
    updateNoCaptureClass(el, binding);
  },
  updated(el, binding) {
    updateNoCaptureClass(el, binding);
  },
};
